import { styledComponent, Typography } from '@hermes/web-components'

export const Button = styledComponent('button')<{ active?: boolean }>`
  color: #11245A;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  font-family: Poppins;
  white-space: nowrap;

  ${({ active }) =>
    active
      ? `
      border: 1px solid #AABDF3;
      background: #D5DEF9;
      border-radius: 50px;
      padding: 6px 16px;`
      : `
      border: 1px solid transparent;
      background: transparent;
      border-radius: 50px;
      padding: 6px 16px;
      `}
  `

export const ButtonText = styledComponent(Typography)({
  fontSize: 'inherit'
})
